import React, { useState } from "react"
import { Modal } from "react-bootstrap"

const Moment = require("moment")
const MomentRange = require("moment-range")
const moment = MomentRange.extendMoment(Moment)

function PopUp(props) {
  const [date, setDate] = useState(props.data)
  const [selected_date, setSelected_date] = useState(props.selected_date)

  const handleClose = () => {
    props.showPopup(false)
  }

  const ShareProfilePopup = () => {
    return (
      <div>
        <Modal
          show={true}
          className="model-for-qualificationForm share-profile-modal"
        >
          <Modal.Header className="mx-0">
            <Modal.Title className="m-auto">
              My Class (
              {selected_date ? moment(selected_date).format("DD-MM-YYYY") : ""})
            </Modal.Title>
            <div onClick={props.toggleCalendar(false)} className="dot"></div>
          </Modal.Header>
          <Modal.Body>
            <div className="model-body">
              <label className="w-100">
                <p className="text-center mt-2">Choose a date range</p>
              </label>
              <div className="row w-100  mt-3 availability-rule-dates-section justify-content-center">
                {/* <div className='col-6 pr-2 pl-5'> */}
                <div className="xs-col-12  pl-5 pr-4">
                  <div className="form-group">
                    <label className="w-100">
                      <p className="float-left mb-0">From</p>
                      {/* <div className='span-hovered'>
															<i className='mdi mdi-information-outline float-right'></i>
															<span className='span-hovered-content'>
																Choose the starting date
															</span>
														</div> */}
                    </label>
                  </div>
                </div>
                {/* <div className='col-6 pl-2 pr-5'> */}
                <div className="xs-col-12 pl-5 pr-4">
                  <div className="form-group">
                    <label className="w-100">
                      <p className="float-left mb-0">To</p>
                      {/* <div className='span-hovered'>
															<i className='mdi mdi-information-outline float-right'></i>
															<span className='span-hovered-content'>
																Choose the ending date
															</span>
														</div> */}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
  return <>{ShareProfilePopup()}</>
}
export default PopUp
